export default __webpack_public_path__ + "static/media/day-dreaming.a31c52d9.jpg";